
<template>
  <div class="nav-header">
    <div class="container">
      <div class="nav">
        <router-link to="/">
          <div class="logo">
            <img src="@/assets/logo.png" alt="" />
            <div class="title">
              <h1>健康追踪仪</h1>
              <i class="iconfont icon-sousuo1x"></i>
            </div>
          </div>
        </router-link>
        <div class="nav-item" @click="toggleActive('home')">
          <span :class="{ actived: activeClass == 'home' }">产品介绍</span>
          <!-- <span class="sanjiao" v-if="activeClass == 'home'"></span> -->
        </div>
        <div class="nav-item" @click="toggleActive('corp')">
          <span :class="{ actived: activeClass == 'corp' }">公司介绍</span>
        </div>
        <div class="nav-item" @click="toggleActive('download')">
          <span :class="{ actived: activeClass == 'download' }">立即下载</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "headers",
    components: {},
    data() {
      return {
        activeClass: "home",
      };
    },
    watch:{
        $route:{
            handler(nval){
                console.log(nval,'nval');
                this.activeClass = nval.name;
            }
        }
    },
    methods: {
      toggleActive(name) {
        this.activeClass = name;
        localStorage.setItem('activeClass',name);
        this.$router.push({name})
        this.$nextTick(()=>{
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        })
      }
    },
    mounted() {
      let _this = this;
      
    //   let activeClass = localStorage.getItem("activeClass");
    //   activeClass && (this.activeClass = activeClass);
      this.$nextTick(()=>{
        console.log(this.$route,'route');
      })
    },
  };
</script>

<style scoped lang="less">
 .nav-header {
      height: 70px;
      width: 100%;
      position: fixed;
      top: 0;
      display: flex;
      justify-content: center;
      background: #fff;
      color: #333333;
      z-index: 9;
      .container {
        width: 1200px;
      }
      .nav {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        .logo {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 7px;
          }
          .title {
            h1 {
              display: inline-block;
              color: #000;
              font-weight: bold;
              font-size: 26px;
              margin-right: 13px;
            }
            span {
              display: inline-block;
              color: #999999;
              font-size: 18px;
            }
          }
        }
        .nav-item {
          cursor: pointer;
          text-align: center;
          height: 70px;
          line-height: 70px;
          font-size: 18px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 30px;
          color: #333;
          -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Chrome/Safari/Opera */
          -khtml-user-select: none; /* Konqueror */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently not supported by any browser */
          text-decoration: none;
          &:hover {
            // color: #f3c33d;
          }
          span {
            cursor: pointer;
            padding-top: 5px;
            &.actived {
              // color: #f3c33d;
              color:#3754fe;
              position: relative;
              &::after{
                content:"";
                height:5px;
                width:30px;
                position: absolute;
                bottom:15px;
                left:50%;
                transform: translateX(-50%);
                background: #3754fe;
              }
            }
          }
          .sanjiao {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 11px;
            width: 29px;
            // background: url("../assets/img1.png") no-repeat;
            background-size: 100%;
          }
        }
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/header.vue